/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapDispatchToProps = exports.mapStateToProps = exports.RenderControls = void 0;

var react_1 = __importDefault(require("react"));

var redux_1 = require("redux");

var brightsmith_core_1 = require("brightsmith-core");

var brightsmith_redux_1 = require("brightsmith-redux");

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'RenderControls';
exports.name = name;

var RenderControls = function RenderControls(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.setActiveView = _this.setActiveView.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "setActiveView",
      value: function setActiveView(index) {
        var actions = this.props.actions;
        actions.ui.setActiveView(index);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _a;

        var _this$props = this.props,
            activeView = _this$props.activeView,
            after = _this$props.after,
            before = _this$props.before,
            _this$props$classes = _this$props.classes,
            classes = _this$props$classes === void 0 ? {} : _this$props$classes,
            model = _this$props.model,
            type = _this$props.type;

        switch (type) {
          case 'toggle':
            return react_1.default.createElement(Frame, {
              className: ['RenderControls__controls-container', classes === null || classes === void 0 ? void 0 : classes.container],
              style: styles === null || styles === void 0 ? void 0 : styles.container
            }, before, react_1.default.createElement(Frame, {
              className: ['RenderControls__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
              style: styles === null || styles === void 0 ? void 0 : styles.inner
            }, (_a = model === null || model === void 0 ? void 0 : model.views) === null || _a === void 0 ? void 0 : _a.map(function (view, index) {
              var _ref2;

              var toggleStyle = Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.toggle, index === 0 ? styles === null || styles === void 0 ? void 0 : styles.toggleFirst : {}, index === (model === null || model === void 0 ? void 0 : model.views.length) - 1 ? styles === null || styles === void 0 ? void 0 : styles.toggleLast : {}, activeView === index ? styles === null || styles === void 0 ? void 0 : styles.toggleActive : {});
              return react_1.default.createElement(Text, {
                className: ['RenderControls__controls-toggle', classes === null || classes === void 0 ? void 0 : classes.toggle, (_ref2 = {}, _defineProperty(_ref2, classes.toggleActive, activeView === index), _defineProperty(_ref2, classes.toggleFirst, index === 0), _defineProperty(_ref2, classes.toggleLast, index === (model === null || model === void 0 ? void 0 : model.views.length) - 1), _ref2)],
                key: view,
                onClick: function onClick() {
                  return _this2.setActiveView(index);
                },
                style: toggleStyle
              }, view);
            })), after);

          case 'dots':
          default:
            return react_1.default.createElement(Frame, {
              className: ['RenderControls__controls-container', classes === null || classes === void 0 ? void 0 : classes.container],
              style: styles === null || styles === void 0 ? void 0 : styles.container
            }, before, react_1.default.createElement(Frame, {
              className: ['RenderControls__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
              style: styles === null || styles === void 0 ? void 0 : styles.inner
            }, model === null || model === void 0 ? void 0 : model.views.map(function (view, index) {
              return react_1.default.createElement(Frame, {
                className: ['RenderControls__controls-dot', classes === null || classes === void 0 ? void 0 : classes.dot, _defineProperty({}, classes.dotActive, activeView === index)],
                key: view,
                onClick: function onClick() {
                  return _this2.setActiveView(index);
                },
                style: styles === null || styles === void 0 ? void 0 : styles.dot
              });
            })), after);
        }
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.RenderControls = RenderControls;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api,
      ui = state.ui;
  var configuration = api.configuration;
  var activeView = ui.activeView;
  var db = new BrightsmithDb(api);
  var model = db.getCurrentModel();
  return {
    activeView: activeView,
    configuration: configuration,
    model: model
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    actions: {
      ui: {
        setActiveView: redux_1.bindActionCreators(brightsmith_redux_1.Actions.Ui.setActiveView, dispatch)
      }
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

  return {
    container: Object.assign({
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginBottom: 15,
      marginTop: 15
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.RenderControls) === null || _a === void 0 ? void 0 : _a.container),
    dot: Object.assign({
      borderColor: (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary,
      borderRadius: 12,
      borderStyle: 'solid',
      borderWidth: 2,
      cursor: 'pointer',
      marginLeft: 3,
      marginRight: 3,
      height: 12,
      width: 12
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.RenderControls) === null || _c === void 0 ? void 0 : _c.dot),
    dotActive: Object.assign({
      backgroundColor: (_d = theme.colors) === null || _d === void 0 ? void 0 : _d.primary
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.RenderControls) === null || _e === void 0 ? void 0 : _e.dotActive),
    inner: Object.assign({
      display: 'flex',
      flexDirection: 'row'
    }, (_f = theme === null || theme === void 0 ? void 0 : theme.RenderControls) === null || _f === void 0 ? void 0 : _f.inner),
    toggle: Object.assign({
      backgroundColor: (_g = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _g === void 0 ? void 0 : _g.secondary,
      borderColor: (_h = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _h === void 0 ? void 0 : _h.primary,
      boxSizing: 'border-box',
      color: '#fff',
      cursor: 'pointer',
      fontSize: 13,
      height: 25,
      lineHeight: '24px',
      overflow: 'hidden',
      textAlign: 'center',
      textTransform: 'capitalize',
      width: 80
    }, (_j = theme === null || theme === void 0 ? void 0 : theme.RenderControls) === null || _j === void 0 ? void 0 : _j.toggle),
    toggleActive: Object.assign({
      backgroundColor: '#333'
    }, (_k = theme === null || theme === void 0 ? void 0 : theme.RenderControls) === null || _k === void 0 ? void 0 : _k.toggleActive),
    toggleFirst: Object.assign(Object.assign(Object.assign({}, StyleUtils_1.default.borderRadius('5px 0 0 5px')), {
      color: '#fff'
    }), (_l = theme === null || theme === void 0 ? void 0 : theme.RenderControls) === null || _l === void 0 ? void 0 : _l.toggleFirst),
    toggleLast: Object.assign(Object.assign(Object.assign({}, StyleUtils_1.default.borderRadius('0 5px 5px 0')), {
      color: '#fff'
    }), (_m = theme === null || theme === void 0 ? void 0 : theme.RenderControls) === null || _m === void 0 ? void 0 : _m.toggleLast)
  };
};

exports.style = style;